module.exports = __webpack_public_path__ + "img/flag-red.f55e28a8.svg";